import React, { Component } from 'react'
import { AlphanumericInputWithMask } from '@lmig/lmds-react'

class TrackingNumber extends Component {
  render() {
    const { onChangeValue } = this.props
    const regex = /^[a-zA-Z0-9_.-]*$/
    return (
      <div>
        <AlphanumericInputWithMask
          name='trackingNum'
          id='Alphanumeric--trackingNum'
          labelVisual='Tracking Number'
          onChange={function (e) {
            onChangeValue(e)
          }.bind(this)}
          mask={{mask: regex}}
        />
      </div>
    )
  }
}

export default TrackingNumber
